module.exports = __webpack_public_path__ + "images/ORY.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo/ORY.png
// module id = 136
// module chunks = 0